import { render, staticRenderFns } from "./Sectors.vue?vue&type=template&id=105cc20e&scoped=true"
import script from "./Sectors.vue?vue&type=script&setup=true&lang=js"
export * from "./Sectors.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105cc20e",
  null
  
)

export default component.exports